angular.module("elencoBeni.components", ['app.services']).component("elencoBeni", {
    templateUrl: "ng/components/dettaglioContratto/elencoBeni/elencoBeni.view.html",
    bindings: {
        listBeni: "=",
        isPending: "<",
        isTargato: "<" 
    },
    controllerAs: "elencoBeniCtrl",
    controller: function ElencoBeni() {
        var self = this;

        self.$onInit = function () {
            self.listBeni = self.listBeni;
            self.isPending = self.isPending;
            $('#accordion').addClass('p-0');
        };
    }
});